/*
 * @Author: zwh2 zwh2@meitu.com
 * @Date: 2025-05-27 10:26:01
 * @LastEditors: zwh2 zwh2@meitu.com
 * @LastEditTime: 2025-06-25 21:02:32
 * @FilePath: /roboneo-web/src/components/roboneo/base/Button/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { useRef } from 'react';
import { useLongPress } from 'ahooks';
import classNames from 'classnames';
import style from './index.module.scss';

interface Props {
  type?: 'primary' | 'default' | 'black' | 'transparent' | 'plain';
  block?: boolean;
  size?: 'small' | 'normal' | 'large';
  disabled?: boolean;
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  color?: string;
  children?: React.ReactNode;
  className?: string;
  onMouseDown?: React.MouseEventHandler<HTMLButtonElement>;
  onMouseUp?: React.MouseEventHandler<HTMLButtonElement>;
  buttonStyle?: React.CSSProperties;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  onMouseEnter?: React.MouseEventHandler<HTMLButtonElement>;
  onMouseLeave?: React.MouseEventHandler<HTMLButtonElement>;
  onLongPress?: (event: MouseEvent | TouchEvent) => void;
  onLongPressEnd?: (event: MouseEvent | TouchEvent) => void;
  longPressDelay?: number;
  id?: string;
  'aria-label'?: string;
}

export default function Button({
  type = 'default',
  size = 'normal',
  block = false,
  disabled = false,
  leftIcon,
  rightIcon,
  color,
  children,
  className,
  onClick,
  onMouseDown,
  onMouseUp,
  buttonStyle = {},
  onMouseEnter,
  onMouseLeave,
  id,
  'aria-label': ariaLabel,
  onLongPress,
  onLongPressEnd,
  longPressDelay = 500,
}: Props) {
  const buttonRef = useRef<HTMLButtonElement>(null);

  useLongPress(
    (e) => {
      if (disabled) return;
      onLongPress?.(e);
    },
    (onLongPress || onLongPressEnd) && !disabled ? buttonRef : undefined,
    {
      delay: longPressDelay,
      onClick: (e) => {
        if (disabled) return;
        onClick?.(e as unknown as React.MouseEvent<HTMLButtonElement>);
      },
      onLongPressEnd: (e) => {
        if (disabled) return;
        onLongPressEnd?.(e);
      },
    },
  );

  return (
    <button
      ref={buttonRef}
      id={id}
      aria-label={ariaLabel}
      style={{ color, width: block ? '100%' : 'max-content', ...buttonStyle }}
      className={classNames(style.button_box, style[type], style[size], className, {
        [style.disabled]: disabled,
      })}
      // disabled={disabled}
      onClick={
        onLongPress || onLongPressEnd
          ? undefined
          : (e) => {
            if (disabled) return;
            onClick?.(e);
          }
      }
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onMouseDown={onMouseDown}
      onMouseUp={onMouseUp}
    >
      {leftIcon && (
        <span className={style.left_icon_box}>{leftIcon}</span>
      )}

      {children}

      {rightIcon && (
        <div className={style.right_icon_box}>
          {rightIcon}
        </div>
      )}
    </button>
  );
}
